exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reward-upload .el-upload{max-width:54px !important;max-height:54px !important;width:54px !important;height:54px !important}.reward-upload button{max-width:54px !important;max-height:54px !important;width:54px !important;height:54px !important}\n", ""]);

// exports
